import { useCallback } from 'react';
import useDatabase from '@pkg/database/useDatabase';
import useMutation from '@pkg/graphql/useMutation';
import createInput from './createInput';

const UPDATE_PROPERTY = /* GraphQL */ `
  mutation UpdateLibraryProperty($input: UpdateLibraryPropertyInput!) {
    updateLibraryProperty(input: $input) {
      uuid
      name
    }
  }
`;

/**
 * @return {Function}
 */
export default function useUpdate() {
  const database = useDatabase();
  const { mutateAsync } = useMutation({
    mutation: UPDATE_PROPERTY,
  });

  /**
   * @param {Object} property
   * @param {Object} input
   * @param {String} input.name
   * @param {String|null} input.color
   * @param {Array} input.options
   * @returns {Promise}
   */
  function updateProperty(property, input) {
    const payload = {};
    if (input.name) {
      payload.name = input.name;
    }

    if ('color' in input) {
      payload.color = input.color;
    }

    if (input.options) {
      payload.options = input.options;
    }

    database.properties.update(property.uuid, payload); // @todo rollback
    const computed = createInput(property, payload);
    return mutateAsync(computed);
  }

  return useCallback(updateProperty, [mutateAsync]);
}
